export default "__VITE_ASSET__CQdz4ZZ8__"